import React from "react";
import { SEGMENT_BZA, SEGMENT_CMC } from "../../constants";

interface HeroPackageProps {
	label?: typeof SEGMENT_CMC | typeof SEGMENT_BZA | "Most Popular";
	title?: string;
	description?: string;
	subtitle?: string;
	features?: string[];
	subscribeLinkUrl?: string;
}

export function HeroPackage({
	label,
	title = "Subscription",
	description,
	subtitle,
	features,
	subscribeLinkUrl,
}: HeroPackageProps) {
	const list = features?.map((item, index) => <li key={index}>{item}</li>);

	const featuresList = (
		<ul className="ticks ticks--small">
			{list}
			<li>Comprehensive search filters</li>
			<li>Regular updates to ensure up-to-date insights</li>
		</ul>
	);

	const buttons = (
		<div className="btn-group btn-group-vertical">
			<a href={subscribeLinkUrl} className="btn btn--primary">
				Buy/Trial
			</a>
		</div>
	);

	return (
		<div className="subscription">
			{label && (
				<header>
					<span>{label}</span>
				</header>
			)}
			<div className="content typography">
				<p className="title">{title}</p>
				{subtitle && <p className="subtitle">{subtitle}</p>}
				<div className="typography">
					{description && <p>{description}</p>}
					{featuresList}
				</div>
				{buttons}
			</div>
		</div>
	);
}
